module.exports = "pegasus/assets/tech/email1-gallery-img3.png";